import {get, post, del, put} from '@/api';
import * as FCFS from '../constants/fcfs';
import queryString from 'query-string';

export default {
  /**
   * Get the list of queue
   *
   * @param commit
   * @param param
   * @returns {PromiseLike<T> | Promise<T> | *}
   */
  [FCFS.ACTION_LIST_QUEUE]: ({commit}, param) => {
    const qs = queryString.stringify(param, {arrayFormat: 'bracket'});
    return get(`/queue?${qs}`).then((res) => {
      commit(FCFS.MUTATE_LIST_QUEUE, res.data);
    })
  },

  [FCFS.ACTION_GET_QUEUE]: ({commit}, id) => {
    const promise = get(`/queue/${id}`);
    promise.then(res => {
      commit(FCFS.MUTATE_QUEUE, res.data);
    });
    return promise;
  },

  /**
   * Add a certain queue from the list. Note that we're
   * returning a new list instead of the newly added queue.
   * This is to make sure that we're getting the latest queue
   * from the server.
   *
   * @param commit
   * @param payload
   * @returns {PromiseLike<T> | Promise<T> | *}
   */
  [FCFS.ACTION_ADD_QUEUE]: ({commit}, payload) => {
    return post(`/queue`, payload);
  },

  /**
   * Delete a certain queue from the list. Note that we're
   * returning a new list instead of the newly added queue.
   * This is to make sure that we're getting the latest queue
   * from the server.
   *
   * @param commit
   * @param payload
   * @returns {PromiseLike<T> | Promise<T> | *}
   */
  [FCFS.ACTION_DELETE_QUEUE]: ({commit}, payload) => {
    return del(`/queue/${payload.id}`);
  },

  /**
   * Update queue.
   *
   * @param commit
   * @param data
   * @returns {*}
   */
  [FCFS.ACTION_UPDATE_QUEUE]: ({commit}, data) => {
    return put(`/queue/${data.id}`, data.payload);
  },

  /**
   * Get the last record from the queue.
   *
   * @param commit
   * @param doctorId
   * @returns {PromiseLike<T> | Promise<T> | *}
   */
  [FCFS.ACTION_GET_LAST_QUEUE]: ({commit}, doctorId) => {
    const priority = get(`/queue/last-priority/${doctorId}`);

    priority.then(res => {
      commit(FCFS.MUTATE_LAST_QUEUE, res.data)
    });
    return priority;
  }
}



// WEBPACK FOOTER //
// ./src/store/fcfs/actions.js